export default {
  sections: {
    address: 'Adres',
    legal_address: 'Adres rejestracyjny',
    invoice_address: 'Adres do faktury',
  },
  form: {
    display_name: {
      label: 'Nazwa wyświetlana',
      placeholder: 'Wprowadź nazwę wyświetlaną firmy',
    },
    legal_name: {
      label: 'Nazwa prawna',
      placeholder: 'Wprowadź nazwę prawną',
      tooltip: 'Nazwa rejestracyjna. Wyświetlana w raportach wypłat, umowie itp.',
    },
    timezone: {
      label: 'Strefa czasowa',
    },
    has_dedicated_invoice_address: {
      label: 'Inne dane do rozliczeń',
    },
  },
  buttons: {
    next: 'Dalej',
  },
};
